import React from 'react';
import { Card } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import './ServedCustomers.styles.scss';

interface CustomerService {
	served: number;
	unservedNonDefaulter: number;
	unservedDefaulter: number;
}

interface Props {
	servedCustomers: CustomerService;
}

const ServedCustomers = ({ servedCustomers }: Props) => {
	return (
		<div className="div-indicador">
			{/* @ts-ignore */}
			<Card>
				{/* @ts-ignore */}
				<Card.Header style={{ fontWeight: 'bold' }}>
					Visão Geral da Carteira para a Coleção
				</Card.Header>
				{/* @ts-ignore */}
				<Card.Body>
					<div className="served-customers">
						<div>
							<NumberFormat
								displayType="text"
								prefix={'Clientes Atendidos: '}
								fixedDecimalScale
								value={servedCustomers?.served ?? 0}
							/>
						</div>
						<div>
							<NumberFormat
								displayType="text"
								prefix={'À Atender Regulares: '}
								fixedDecimalScale
								value={servedCustomers?.unservedDefaulter ?? 0}
							/>
						</div>
						<div>
							<NumberFormat
								displayType="text"
								prefix={'À Atender Inadimplentes: '}
								fixedDecimalScale
								value={servedCustomers?.unservedNonDefaulter ?? 0}
							/>
						</div>
					</div>
				</Card.Body>
			</Card>
		</div>
	);
};

export default ServedCustomers;
